import React from 'react'
const togetherCustomerKey = {
  name: '성함',
  login_count: '로그인 횟수',
  gold: '보유 골드',
  last_login_date: '최근로그인시각',
  created_at: '가입일',
}
const matchingKey = {
  orderId: '상품주문번호',
  orderDetailId: '세부상품주문번호',
  createdAt: '주문일시',
  paymentCreatedAt: '결제일',
  orderDetailStatus: '주문상태',
  productId: '상품번호',
  productName: '상품명',
  optionId: '옵션ID',
  optionTitle: '옵션상품명',
  quantity: '수량',
  totalPrice: '주문금액',
  price: '상품금액',
  couponDiscountPrice: '할인금액',
  createdByName: '구매자ID',
  usePoint: '포인트사용유무',
  sellerName: '셀러명',
  name: '수취인명',
  phone: '수취인연락처',
  birthday: '생년월일',
  address: '배송지',
  addressRequest: '배송메시지',
  deliveryCompany: '택배사',
  trackingNumber: '송장번호',
  shipDate: '발송일',

  type: '구분',
  purchasePath: '구매 경로',
  profitPrice: '정산 금액',
  total_sales_price: '판매 금액',
  fee_total: '수수료 합계',
  commissionDy: '당영 관리 수수료',
  commissionSell: '매출 연동 수수료',
  delivery_price: '배송 관리 수수료',
  profit_amount: '수익 금액',

  settlement_month: '정산 월',
  settlement_complete_date: '정산 완료일',
  settlement_status: '정산 상태',

  giftFromName: '구매자명',
  giftToName: '수취인명',
  giftFromPhone: '구매자 연락처',
  giftToDate: '수락기한',

  // 닥터체크용
  order_id_dk: '주문번호',
  option_title_dk: '옵션명',
  // unit_sales_price: "판매단가",
  // sales_price: "판매금액",
  unit_sales_price: '옵션 가격',
  sales_price: '가격',
  tracking_number_dk: '운송장번호',
  recipient: '수령자',
  contact: '전화',
  phone_dk: '핸드폰',
  postal_code: '우편번호',
  address_dk: '주소',
  address_request_dk: '배송메세지',
  delivery_price_dk: '배송비',
  num_of_tracking_number: '송장출력갯수',
}
const matchingOrderStatus = {
  order_request: '주문생성',
  ready: '입금대기',
  paid: '입금완료',
  failed: '결제실패',
  cancelled: '결제취소',
  delivery_ready: '배송준비중',
  delivery_shipping: '배송중',
  delivery_complete: '배송완료',
  complete: '구매확정',
  cancel_request: '취소요청',
  cancel_complete: '취소완료',
  exchange_request: '교환요청',
  exchange_complete: '교환완료',
  return_request: '반품요청',
  return_receive: '반품승인',
  return_refusal: '반품거부/철회',
  return_collection_complete: '반품수거완료',
  return_collection_fail: '반품수거취소',
  return_delivery: '반품배송중',
  return_delivery_complete: '반품배송완료',
  return_complete: '반품완료',
  address_ready: '수락대기',
}

const matchingDeliveryCompany = {
  DHL: 'DHL',
  // 'jp.sagawa': 'Sagawa',
  // 'jp.yamato': 'Kuroneko Yamato',
  // 'jp.yuubin': 'Japan Post',
  CHUNIL: '천일택배',
  KOREX: 'CJ대한통운',
  CUHOME: 'CU 편의점택배',
  CVSNET: 'GS Postbox 택배',
  // 'kr.cway': 'CWAY (Woori Express)',
  DAESIN: '대신택배',
  EPOST: '우체국 택배',
  HPL: '한의사랑택배',
  HANJIN: '한진택배',
  HDEXP: '합동택배',
  HOMEPICK: '홈픽',
  HONAM: '한서호남택배',
  ILYANG: '일양로지스',
  KDEXP: '경동택배',
  KUNYOUNG: '건영택배',
  LOGEN: '로젠택배',
  LOTTE: '롯데택배',
  SLX: 'SLX',
  SWGEXP: '성원글로벌카고',
  TNT: 'TNT',
  EMS: 'EMS',
  FEDEX: 'Fedex',
  UPS: 'UPS',
  USPS: 'USPS',
}

const matchingProvider = {
  guest: '게스트로그인',
  kakao: '카카오로그인',
  naver: '네이버로그인',
  apple: '애플로그인',
  phone: '휴대폰로그인',
}

const matchingPointHistory = {
  PURCHASE_COMPLETE: '상품 구매 확정 포인트 지급', // 구매 확정
  PURCHASE_USE: '상품 구매에 사용', // 구매시 사용
  PURCHASE_CANCEL: '상품 구매 취소로 포인트 회수', // 구매 취소
  REVIEW_COMPLETE: '리뷰 작성 포인트 지급', // 리뷰 작성
  REVIEW_CANCEL: '리뷰 삭제 포인트 차감', // 리뷰 취소
  // purchase_use: '상품 구매에 사용',
  // review_complete: '리뷰 작성 포인트 지급',
  // review_cancel: '리뷰 삭제 포인트 차감',
  // review_complete_cancel: '구매 취소로 리뷰 적립 포인트 차감',
  // purchase_complete: '상품 구매 확정 포인트 지급',
  // purchase_complete_cancel: '구매 취소로 상품 구매 확정 포인트 차감',
  // purchase_saving_point_complete: '상품 구매 확정 포인트 지급',
  // purchase_cancel: '상품 구매 취소로 포인트 회수',
}

const matchingPayMethod = {
  card: '카드',
  vbank: '가상 계좌',
  naverpay: '네이버페이',
  point: '포인트결제',
  deposit: '무통장입금',
  kakaopay: '카카오페이',
  tosspay: '토스페이',
  lpay: '엘페이',
}

const orderStatusChange = (value) => {
  switch (value) {
    case 'order_request':
      return <span>주문생성</span>
    case 'ready':
      return <span>입금대기</span>
    case 'paid':
      return <span>입금완료</span>
    case 'cancelled':
      return <span>결제취소</span>
    case 'failed':
      return <span>결제실패</span>
    case 'delivery_ready':
      return <span>배송준비중</span>
    case 'delivery_shipping':
      return <span>배송중</span>
    case 'delivery_complete':
      return <span>배송완료</span>
    case 'complete':
      return <span>구매확정</span>
    case 'cancel_request':
      return <span>취소요청</span>
    case 'cancel_complete':
      return <span>취소완료</span>
    case 'exchange_request':
      return <span>교환요청</span>
    case 'exchange_complete':
      return <span>교환완료</span>
    case 'return_request':
      return <span>반품요청</span>
    case 'return_receive':
      return <span>반품승인</span>
    case 'return_refusal':
      return <span>반품거부/철회</span>
    case 'return_collection_complete':
      return <span>반품수거완료</span>
    case 'return_collection_fail':
      return <span>반품수거취소</span>
    case 'return_delivery':
      return <span>반품배송중</span>
    case 'return_delivery_complete':
      return <span>반품배송완료</span>
    case 'return_complete':
      return <span>반품완료</span>
    default:
      return <span>-</span>
  }
}

const deliveryStatusChange = (value) => {
  switch (value) {
    case 'register_return_tracking_number':
      return <span>수거 송장 등록</span>
    case 'transferred':
      return <span>배송사 이관</span>
    case 'pickup':
      return <span>수거 완료</span>
    case 'in_transit':
    case 'dlv_start':
      return <span>배송중</span>
    case 'pickup_failed':
      return <span>수거 취소</span>
    case 'completed':
      return <span>배송 완료</span>
    default:
      return <span>수거 대기</span>
  }
}

const replaceReviewBodyList = [
  ['피로', '피*'],
  ['시력', '사*'],
  ['효과', '효*'],
  ['뻑뻑', '뻑*'],
  ['두통', '두*'],
  ['증상', '증*'],
  ['녹내장', '녹**'],
  ['안구건조증', '안****'],
  ['피곤', '피*'],
  ['집중력', '집**'],
  ['머리', '머*'],
  ['노화', '노*'],
  ['머리카락', '머***'],
  ['변비', '변*'],
  ['예방', '예*'],
  ['고혈압', '고**'],
  ['기능', '*능'],
  ['자궁', '자*'],
  ['피로회복', '피*회*'],
  ['회복', '회*'],
  ['담낭', '담*'],
  ['숙취', '숙*'],
  ['변화', '변*'],
  ['활력', '활*'],
  ['면역', '면*'],
  ['면역력', '면**'],
  ['설사', '설*'],
]

const statusUtil = {
  togetherCustomerKey,
  matchingKey,
  matchingOrderStatus,
  matchingDeliveryCompany,
  matchingProvider,
  matchingPointHistory,
  matchingPayMethod,
  orderStatusChange,
  deliveryStatusChange,
  replaceReviewBodyList,
}

export default statusUtil
